import { VALIDATION_TEMPLATE } from './validationTemplete';

export const COST_VALIDATION = {
  FIELDS: ['costCategoryId', 'detail', 'date', 'price'],
  MESSAGE: {
    costCategoryId: {
      required: VALIDATION_TEMPLATE.required('費用分類'),
    },
    detail: {
      required: VALIDATION_TEMPLATE.required('内容'),
      maxLength: VALIDATION_TEMPLATE.maxLength('内容', 100),
    },
    date: {
      required: VALIDATION_TEMPLATE.required('検収日'),
    },
    price: {
      required: VALIDATION_TEMPLATE.required('金額'),
      isHalfWidth: VALIDATION_TEMPLATE.isHalfWidth('金額'),
      isPositiveInteger: VALIDATION_TEMPLATE.isPositiveInteger(),
    },
  },
  RULES: {
    costCategoryId: {
      required: true,
    },
    detail: {
      required: true,
      maxLength: /^.{1,100}$/,
    },
    date: {
      required: true,
    },
    price: {
      required: true,
      isHalfWidth: /^[0-9]+$/,
      isPositiveInteger: /^[1-9][0-9]*$/,
    },
  },
};
